const Navbar = () => {
  return (
    <nav className="bg-slate-900 text-white p-4 shadow-md fixed top-0 w-full z-10"> {/* Charcoal Black */}
      <div className="container mx-auto flex justify-between items-center">
        <a href="/" className="text-2xl font-bold">P2F2</a>
        <ul className="flex space-x-6">
          <li><a href="#home" className="hover:underline">Home</a></li>
          <li><a href="#plans" className="hover:underline">Plans</a></li>
          <li><a href="#reviews" className="hover:underline">Reviews</a></li>
          <li><a href="#contact" className="hover:underline">Contact</a></li>
          <li><a href="/admin" className="hover:underline">Admin</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;